import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'

const initialState = {
  open: false,
  page: 0,
  rowsPerPage: 5,
  openConfirmDialog: false,
  deleteId: 0,
  tweetList: null,
}

const tweetListDialog = (state = initialState, action) => {
  var newState = deepCopy(state)
  switch (action.type) {
    case types.tweetListDialog.OPEN:
      return { ...state, open: true }
    case types.tweetListDialog.CLOSE:
      return { ...state, open: false, tweetList: null, page: 0 }
    case types.tweetListDialog.CHANGED_PAGE:
      return { ...state, page: action.page }
    case types.tweetListDialog.CHANGED_ROWS_PER_PAGE:
      return { ...state, rowsPerPage: action.rowsPerPage }
    case types.tweetListDialog.OPEN_CONFIRM_DIALOG:
      return { ...state, openConfirmDialog: true, deleteId: action.deleteId }
    case types.tweetListDialog.CLOSE_CONFIRM_DIALOG:
      return { ...state, openConfirmDialog: false, deleteId: 0 }
    case types.twitter.RECEIVE_GET_SCHEDULE_TWEET_LIST:
      var cols, dynamic_cols, tweetList
      if (action.response.result){
        tweetList = []
        for (cols of action.response.data){
          dynamic_cols = JSON.parse( cols.dynamic_cols )
          dynamic_cols.id = cols.id
          dynamic_cols.image = cols.image
          tweetList.push( dynamic_cols );
        }
        tweetList.sort((a, b) => {
          if (a.datetime > b.datetime) {
            return 1;
          }
          else if (a.datetime === b.datetime) {
            return 0;
          }
          else {
            return -1;
          }
        })
        newState.tweetList = tweetList
      }
      return newState
    case types.twitter.RECEIVE_DELETE_SCHEDULE_TWEET:
      if (action.response.result) {
        newState.tweetList = newState.tweetList.filter(tweet => tweet.id !== action.deleteId)
      }
      return newState
    default:
      return state
  }
}

export default tweetListDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/MenuAppBar/TweetListDialog.js